import { z } from 'zod';

import { OrgIdSchema } from '../_shared/identifiers';
import { AgentKindSchema } from '../agent/agent';

import { CardIdSchema } from './card_id';

/**
 * Wire contract for the `card.assignment-changed` fact kanban publishes (to
 * the shared card-events SNS topic) when a conversation-backed card changes
 * hands. `operator` (card claimed / transferred to a human) mutes the AI agent
 * (conversation `handledBy='human'`); `agent` (`card.return-to-agent`) hands
 * the chat back to the AI. The conversation service fences the `agent` case to
 * operator-owned chats — a Zendesk-desk chat stays with the desk.
 *
 * `type` discriminates it from `card.created` / `card.meta.updated` on the
 * same topic. The SNS→SQS subscription uses `RawMessageDelivery=true`, so the
 * SQS body is this JSON directly. `messageId` is a publisher UUID for log
 * correlation. `conversationId` is the card's conversation external ref.
 */
export const CardAssignmentChangedEventSchema = z
  .object({
    type: z.literal('card.assignment-changed'),
    messageId: z.uuid(),
    orgId: OrgIdSchema,
    cardId: CardIdSchema,
    conversationId: z.uuid(),
    assigneeKind: AgentKindSchema,
    occurredAt: z.iso.datetime(),
  })
  .strict();

export type CardAssignmentChangedEvent = z.infer<typeof CardAssignmentChangedEventSchema>;
